import React from 'react'
import { Checkbox, Popover } from '@runeffective/evo-design-system'
import { IMapViewSettings } from 'components/AdminFloorPlan/hooks/useMapViewSettings'

interface ItemProps {
  checked: boolean
  name: string
  onclick: any
  value: string
}

function MapFilter({
  triggerElement,
  mapViewSettings,
  updateMapViewSettings,
}: {
  triggerElement: React.ReactNode
  mapViewSettings: any
  updateMapViewSettings: any
}) {
  const items: any = [
    {
      value: 'all',
      name: 'Select All',
      key: 'aSelectAll',
    },
    {
      value: 'department_areas',
      name: 'Department Areas',
      key: 'aDepartment',
    },
    {
      value: 'neighborhoods',
      name: 'Neighborhoods',
      key: 'aNeighborhood',
    },
    {
      value: 'workplace_groups_employee',
      name: 'Employee Workplace Groups',
      key: 'aEWorkplaceGroup',
    },
    {
      value: 'workplace_groups_seat',
      name: 'Seat Workplace Groups',
      key: 'aWorkplaceGroup',
    },
    {
      value: 'teams',
      name: 'Team Areas',
      key: 'aTeam',
    },
  ]

  return (
    <Popover triggerElement={triggerElement}>
      <Popover.Content>
        {items.map(({ value, name, key }: { value: string; name: string; key: string }) => {
          let checked = false
          if (Object.keys(mapViewSettings).length > 0) {
            checked = mapViewSettings[key as keyof IMapViewSettings] === 'On'
          }
          return (
            <Item
              key={value}
              name={name}
              value={value}
              checked={checked}
              onclick={(event: any, name: string) => {
                updateMapViewSettings(
                  key as keyof IMapViewSettings,
                  event ? 'On' : 'Off',
                  items.map(({ key }: { key: string }) => key)
                )
              }}
            />
          )
        })}
      </Popover.Content>
    </Popover>
  )
}

function Item(props: ItemProps) {
  const { checked, name, onclick } = props

  return (
    <div>
      <Checkbox checked={checked} label={name} onChange={(event) => onclick(event, name)} />
    </div>
  )
}

export default MapFilter
